var Theme;

jQuery(document).ready(function(){

	Theme = {

		/**
		 * Init
		 */
		init:function(){

			// Cache elements
			Theme.w = jQuery(window);
			Theme.html = jQuery('html');
			Theme.body = jQuery('body');
			Theme.scrollPosition = 0;
			Theme.scrollParallaxFactor = 0.25;
			Theme.map = jQuery('.map');
			Theme.forms = jQuery('.contact-form, .reserve-form');
			Theme.toggleNav = jQuery('.toggle-nav');

			// Go!
			Theme.bindings();

		},

		bindings:function(){

			// Parallax background
			Theme.w.scroll(function(){
				Theme.scrollPosition = Theme.w.scrollTop();
				Theme.body.css('backgroundPosition', '50% ' + Theme.scrollPosition * Theme.scrollParallaxFactor + 'px');
			});

			// Lightbox
			jQuery('a[href$=".jpg"]').fancybox();

			// Forms
			Theme.forms.submit(function(e){
				e.preventDefault();
				Theme.submitForm( jQuery(this) );
			});

			// Map
			Theme.map.gmap3({
				map: {
					options: {
						maxZoom: 18
					}
				},
				marker:{
					address: "Berliner Promenade 18, 66111 Saarbrücken",
				}
			},
			"autofit" );

			//
			Theme.toggleNav.click(function(e){
				e.preventDefault();
				Theme.body.toggleClass('nav-visible');
			});

		},

		submitForm:function( form, options ) {

			if ( Theme.validateForm( form ) && ( undefined === options || undefined === options.validate || ( options && typeof options.validate === 'function' && true === options.validate() ) ) ) {

				if ( options && typeof options.before === 'function' )
					options.before();

				form.addClass('submitting');
				form.addClass( 'form-send' );

				var button = form.find('button[type=submit]').addClass('loading');
				var data = form.serialize();

				jQuery.post( ajaxurl, data, function(response){

					button.removeClass('loading');

					if ( undefined !== options && false !== options.empty ) {
						form.find('input[type="text"], input[type="email"], input[type="date"], input[type="time"],textarea,select').val('');
						form.find('input[type="radio"], input[type="checkbox"]').removeAttr('checked');
					}

					if ( options && typeof options.response === 'function' )
						options.response(form,response);
					else
						form.before(response);

					if ( options && typeof options.after === 'function' )
						options.after(response);

					form.removeClass('submitting');

				});

			}

		},

		validateForm:function( form ){

			if ( form.hasClass('submitting') || form.hasClass( 'form-send' ) )
				return false;

			// Remove old validation
			jQuery('.error-input').removeClass('error-input');
			form.find('.message').remove();

			// Cache
			var submit = true,
				requiredFields = form.find('input.required, textarea.required, select.required');

			// Validate the fields
			requiredFields.each(function(i,e){
				var obj = jQuery(this);
				if ( '' == obj.val() ) {
					obj.addClass( 'error-input' );
					submit = false;
				}
			});

			return submit;

		}

	};

	Theme.init();

});
